import React from "react";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import { staticPagesTabsData } from "../../../../data/SidebarData";
import Tabs from "../../../../Components/Common/Tabs";
import StaticHomeForm from "./Components/StaticHomeForm";

const StaticHome = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={staticPagesTabsData} />
      <StaticHomeForm
        title="Home"
        customSlug="home"
        typeData={[]}
        type="materials"
      />
    </div>
  );
};

export default StaticHome;
